import { render } from "./ModalWarning.vue?vue&type=template&id=48c096cf&scoped=true"
import script from "./ModalWarning.vue?vue&type=script&lang=js"
export * from "./ModalWarning.vue?vue&type=script&lang=js"

import "@/assets/styles/mystyles.css?vue&type=style&index=0&id=48c096cf&scoped=true&lang=css&external"
import "./ModalWarning.vue?vue&type=style&index=1&id=48c096cf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c096cf"]])

export default __exports__